import type { NormRect } from "../selection/types";

export function clientRectsToNormRects(
  clientRects: DOMRect[],
  pageClientRect: DOMRect
): NormRect[] {
  return clientRects
    .filter((r) => r.width > 0 && r.height > 0)
    .map((r) => ({
      x: (r.left - pageClientRect.left) / pageClientRect.width,
      y: (r.top - pageClientRect.top) / pageClientRect.height,
      w: r.width / pageClientRect.width,
      h: r.height / pageClientRect.height,
    }));
}

export function normRectToAbsolute(
  nr: NormRect,
  pageWidth: number,
  pageHeight: number
) {
  return {
    left: nr.x * pageWidth,
    top: nr.y * pageHeight,
    width: nr.w * pageWidth,
    height: nr.h * pageHeight,
  };
}
